import { render } from "./Orders.vue?vue&type=template&id=72640ce5"
import script from "./Orders.vue?vue&type=script&lang=ts"
export * from "./Orders.vue?vue&type=script&lang=ts"
script.render = render

export default script